module.exports = __webpack_public_path__ + "img/lklm.5590d926.png";